const SECRET_KEY = process.env.SECRET_KEY
export const evall = SECRET_KEY


// WEBPACK FOOTER //
// ./src/configSystem.js